var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1199_5624",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1199_5624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.00008 14.6667C3.63341 14.6667 3.31964 14.5363 3.05875 14.2754C2.79741 14.0141 2.66675 13.7001 2.66675 13.3334V6.66675C2.66675 6.30008 2.79741 5.98608 3.05875 5.72475C3.31964 5.46386 3.63341 5.33342 4.00008 5.33342H4.66675V4.00008C4.66675 3.07786 4.99186 2.29164 5.64208 1.64141C6.29186 0.991637 7.07786 0.666748 8.00008 0.666748C8.9223 0.666748 9.70853 0.991637 10.3587 1.64141C11.0085 2.29164 11.3334 3.07786 11.3334 4.00008V5.33342H12.0001C12.3667 5.33342 12.6807 5.46386 12.9421 5.72475C13.203 5.98608 13.3334 6.30008 13.3334 6.66675V13.3334C13.3334 13.7001 13.203 14.0141 12.9421 14.2754C12.6807 14.5363 12.3667 14.6667 12.0001 14.6667H4.00008ZM4.00008 13.3334H12.0001V6.66675H4.00008V13.3334ZM8.00008 11.3334C8.36675 11.3334 8.68075 11.203 8.94208 10.9421C9.20297 10.6807 9.33342 10.3667 9.33342 10.0001C9.33342 9.63342 9.20297 9.31942 8.94208 9.05808C8.68075 8.79719 8.36675 8.66675 8.00008 8.66675C7.63341 8.66675 7.31964 8.79719 7.05875 9.05808C6.79742 9.31942 6.66675 9.63342 6.66675 10.0001C6.66675 10.3667 6.79742 10.6807 7.05875 10.9421C7.31964 11.203 7.63341 11.3334 8.00008 11.3334ZM6.00008 5.33342H10.0001V4.00008C10.0001 3.44453 9.80564 2.9723 9.41675 2.58341C9.02786 2.19453 8.55564 2.00008 8.00008 2.00008C7.44453 2.00008 6.9723 2.19453 6.58341 2.58341C6.19453 2.9723 6.00008 3.44453 6.00008 4.00008V5.33342Z",
    fill: "#B5B5B5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.e7b8c2a9a2d815e87a9ed01c6db82527.svg";
export { ForwardRef as ReactComponent };